// Used throughout Magento for hyperlinks (pulled out of default magento js.js file)
// =======================

function setLocation(url){
	window.location.href = url;
 	} 